module.exports = __webpack_public_path__ + "img/icon-nonmedical.cc47d983.png";